exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.deal-closed .step-input {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n.deal-closed .step-input:hover {\n  opacity: 0.8;\n}\n", ""]);

// exports
